import cn from 'classnames/bind';
import React__default from 'react';
import { formatPublicationDate } from '@sbt-web/utils';
import classes from './index.module.scss.js';

const cx = cn.bind(classes);
const ItemDateLocation = (props) => {
    const { town, gallerized, cityShortName, className, date } = props;
    return (React__default.createElement("div", { className: cx(className, 'container') },
        town && (React__default.createElement("span", { className: `caption small ${cx('town')}` }, `${town} `)),
        cityShortName && (React__default.createElement("span", { className: `caption small ${cx('city')}` }, `(${cityShortName})`)),
        !gallerized && (React__default.createElement("span", { className: `caption small ${cx('date')} ${cx(town || cityShortName ? 'with-spacer' : '')}`, suppressHydrationWarning: true }, formatPublicationDate(date)))));
};
ItemDateLocation.displayName = 'ItemDateLocation';

export { ItemDateLocation };
//# sourceMappingURL=index.js.map
